import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { userSlice } from "../app/modules/User/_redux/userSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  user: userSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
